import React from 'react';
import { Row, Col, Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import * as I from './Inputs';
import { NextButton } from '../../styles';
import { useRosaContext } from '../../context';
import { VideoContainer } from './VideoContainer';
import { Paragraph, Title } from '@/components/Typography';
import { useUpdateRosaBasicInfo } from '../../hooks/useUpdateRosaBasicInfo';

const { useFormInstance } = Form;

export function Informations() {
	const form = useFormInstance();
	const { organization_id, company_id, file_id, report_id, onNextStep, file } = useRosaContext();

	const { mutateAsync: updateRosaInformations } = useUpdateRosaBasicInfo();

	const formFieldName = 'informations';

	async function handleNextStep(): Promise<void> {
		const formValues = await form.validateFields();

		const { informations } = formValues;

		const payload = {
			company_id,
			organization_id,
			report_id: report_id,
			file_id: file_id,
			report_name: informations.name,
			sector_id: informations.sector_id,
			line_id: informations.line_id,
			workstation_id: informations.workstation_id,
			activity_id: informations.activity_id,
			evaluator_id: informations.evaluator_id,
			collection_date: informations.collection_date,
			analysis_date: informations.analysis_date
		};

		await updateRosaInformations(payload);
		onNextStep();
	}

	return (
		<Row gutter={[0, 40]}>
			<Col span={24}>
				<Row align="middle">
					<Col xs={12}>
						<Title level={4}>{I18n.get('General informations')}</Title>
					</Col>
					<Col xs={24} style={{ marginBottom: '20px' }}>
						<Paragraph>{I18n.get('Enter the data related to the new analysis below')}</Paragraph>
					</Col>
				</Row>
			</Col>
			<Col span={24}>
				<Row gutter={[0, 90]}>
					<Col span={24}>
						<Row justify="center">
							<Col lg={20} xl={14} xxl={10}>
								<Row gutter={[0, 30]}>
									{file && (
										<VideoContainer
											fileId={file.id}
											originalName={file.original_name}
											uploadedDate={file.uploaded_date}
										/>
									)}
									<I.ReportName fieldName={formFieldName} isRequired />
								</Row>
							</Col>
						</Row>
					</Col>
					<Col span={24}>
						<Row justify="center">
							<Col lg={20} xl={14} xxl={10}>
								<Row gutter={[0, 40]}>
									<I.Organization fieldName={formFieldName} disabled isRequired />
									<I.Company fieldName={formFieldName} disabled isRequired />
									<I.Sector fieldName={formFieldName} isRequired />
									<I.Lines fieldName={formFieldName} isRequired />
									<I.Workstation fieldName={formFieldName} isRequired />
									<I.Activity fieldName={formFieldName} isRequired />
								</Row>
							</Col>
						</Row>
					</Col>
					<Col span={24}>
						<Row justify="center">
							<Col lg={20} xl={14} xxl={10}>
								<Row gutter={[0, 40]}>
									<I.Evaluator fieldName={formFieldName} isRequired />
									<I.CollectionDate fieldName={formFieldName} isRequired />
									<I.AnalysisDate fieldName={formFieldName} isRequired />
								</Row>
							</Col>
						</Row>
					</Col>
				</Row>
			</Col>
			<Col span={24} style={{ marginTop: 15 }}>
				<Row justify="center">
					<Col>
						<NextButton type="primary" onClick={handleNextStep}>
							{I18n.get('Next')}
						</NextButton>
					</Col>
				</Row>
			</Col>
		</Row>
	);
}
